import {
    COLOR_BROWN, COLOR_BLACK, COLOR_WHITE, COLOR_YELLOW, COLOR_LIGHT_BLUE, COLOR_DARK_BLUE_80, COLOR_DARK_BROWN, COLOR_GREY_RAINY_DAY, COLOR_GREY_DARK, COLOR_GREY_LIGHT, COLOR_STEAK_SAUCE
} from '../colors';

const notebook = {
    BACKGROUND_PATH: './images/LocalAreaShareable/bg-notebook.jpg',
    HIGHLIGHT_COLOR: COLOR_YELLOW,
    TEXT_COLOR: COLOR_BLACK,
    MONTH_FONT_SIZE: '24px',
    LR_LOGO_PATH: './images/lr-logo-disclaimer-grey.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-grey.svg',
    COMPLIANCE_COLOR: COLOR_STEAK_SAUCE,
    LAYOUT: 'highlight',
};

const birdseye = {
    BACKGROUND_PATH: './images/LocalAreaShareable/bg-birdseye.jpg',
    HIGHLIGHT_COLOR: COLOR_BLACK,
    TEXT_COLOR: COLOR_WHITE,
    MONTH_FONT_SIZE: '24px',
    LR_LOGO_PATH: './images/lr-logo-disclaimer-white.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-white.svg',
    COMPLIANCE_COLOR: COLOR_WHITE,
    LAYOUT: 'highlight',
};

const clouds = {
    BACKGROUND_PATH: './images/LocalAreaShareable/bg-clouds.jpg',
    TEXT_COLOR: COLOR_DARK_BLUE_80,
    LR_LOGO_PATH: './images/lr-logo-disclaimer-dark-blue.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-dark-blue.svg',
    COMPLIANCE_COLOR: COLOR_DARK_BLUE_80,
    LAYOUT: 'grid',
};

const lineart = {
    BACKGROUND_PATH: './images/LocalAreaShareable/bg-lineart.jpg',
    TEXT_COLOR: COLOR_DARK_BROWN,
    LR_LOGO_PATH: './images/lr-logo-disclaimer-brown.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-brown.svg',
    COMPLIANCE_COLOR: COLOR_BROWN,
    LAYOUT: 'grid',
};

const skyline = {
    BACKGROUND_PATH: './images/LocalAreaShareable/bg-skyline.jpg',
    TEXT_COLOR: COLOR_GREY_RAINY_DAY,
    LINE_COLOR: COLOR_LIGHT_BLUE,
    LR_LOGO_PATH: './images/lr-logo-disclaimer-grey.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-grey.svg',
    COMPLIANCE_COLOR: COLOR_STEAK_SAUCE,
    LAYOUT: 'stack',
};

const coins = {
    BACKGROUND_PATH: './images/LocalAreaShareable/bg-coins.jpg',
    TEXT_COLOR: COLOR_WHITE,
    LINE_COLOR: COLOR_WHITE,
    PRICE_PADDING_TOP: '80px',
    LR_LOGO_PATH: './images/lr-logo-disclaimer-white.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-white.svg',
    COMPLIANCE_COLOR: COLOR_WHITE,
    LAYOUT: 'stack',
};

const contrast = {
    BACKGROUND_PATH: './images/LocalAreaShareable/bg-contrast.jpg',
    TEXT_COLOR: COLOR_BLACK,
    LINE_COLOR: COLOR_GREY_LIGHT,
    LR_LOGO_PATH: './images/lr-logo-disclaimer-grey.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-grey.svg',
    COMPLIANCE_COLOR: COLOR_STEAK_SAUCE,
    LAYOUT: 'columns',
};

const typewriter = {
    BACKGROUND_PATH: './images/LocalAreaShareable/bg-typewriter.jpg',
    TEXT_COLOR: COLOR_GREY_DARK,
    AREA_FONT_FAMILY: 'Caveat',
    AREA_FONT_WEIGHT: 700,
    MONTH_FONT_SIZE: '32px',
    MONTH_MARGIN_BOTTOM: '8px',
    FONT_FAMILY: 'Courier Prime',
    LR_LOGO_PATH: './images/lr-logo-disclaimer-grey.svg',
    EQUAL_HOUSING_LOGO_PATH: './images/equal-housing-logo-grey.svg',
    COMPLIANCE_COLOR: COLOR_STEAK_SAUCE,
    LAYOUT: 'gridlines',
};

export const skins = {
    notebook,
    birdseye,
    clouds,
    lineart,
    skyline,
    coins,
    contrast,
    typewriter,
};

export const LAYOUT_CONSTANTS = {
    highlight: {
        WRAP_PADDING: '60px',
        AREA_FONT_SIZE: '48px',
        AREA_LINE_HEIGHT: '68px',
    },
    grid: {
        WRAP_PADDING: '34px',
        AREA_FONT_SIZE: '34px',
        AREA_LINE_HEIGHT: '48px',
    },
    gridlines: {
        WRAP_PADDING: '24px',
        AREA_FONT_SIZE: '48px',
        AREA_FONT_WEIGHT: '700',
        AREA_LINE_HEIGHT: '48px',
    },
    stack: {
        WRAP_PADDING: '34px',
        AREA_FONT_SIZE: '48px',
        AREA_FONT_WEIGHT: '700',
        AREA_LINE_HEIGHT: '68px',
    },
    columns: {
        WRAP_PADDING: '34px',
        AREA_FONT_SIZE: '18px',
        AREA_FONT_WEIGHT: '700',
        AREA_LINE_HEIGHT: '68px',
    },
};
